import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-299a4a33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = ["src", "width", "onClick"]
const _hoisted_3 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1))
const _hoisted_5 = {
  class: "modal-dialog modal-lg",
  role: "document"
}
const _hoisted_6 = ["src"]

import { ref } from 'vue'
import { Draw } from '@/data/models/Draw'
import MasonryWall from '@yeger/vue-masonry-wall'


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawComponent',
  props: {
    drawings: null,
    columnWidth: null,
    gap: null
  },
  setup(__props: any) {



const url = ref('')

function showDraw(item: string){
  url.value = item
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MasonryWall), {
      items: __props.drawings,
      "column-width": __props.columnWidth,
      gap: __props.gap,
      rtl: false
    }, {
      default: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: item.smallUrl,
            width: __props.columnWidth,
            onClick: ($event: any) => (showDraw(item.largeUrl)),
            "data-bs-toggle": "modal",
            "data-bs-target": "#exampleModal"
          }, null, 8, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["items", "column-width", "gap"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: url.value,
          class: "img-fluid rounded"
        }, null, 8, _hoisted_6)
      ])
    ])
  ], 64))
}
}

})